import { useEffect, useRef } from "react"
import { Link, useLocation, useNavigate, useOutletContext, useSearchParams } from "react-router-dom"
import moment from "moment/moment"
import nProgress from "nprogress"
import { useAuth } from "contexts/auth-context"
import { Pagination } from "components"
import { lang } from "config"
import { Pencil, Plus } from "components/icons/outline"
import { usePage } from "contexts/page-context"
import useStockTransferRepositories from "repositories/stock-transfer"     // ⟵ ganti repository
import Table from "components/table"

// ⚠️ Filter/Delete: sementara tetap pakai Filter yang lama jika kompatibel.
// Jika sudah ada filter khusus transfer, ganti import ke: "pages/stock-transfer/filter"
import Filter from "pages/reward/filter"
// Hapus Delete dulu (aksi hapus transfer biasanya tidak diizinkan). Tambahkan nanti jika perlu.
// import Delete from "pages/stock-transfer/delete"

export default function List() {
  // Logged in user ability
  const { can, isSuper, currentBranch } = useAuth()
  // Configuration
  const { configuration } = usePage()

  // Transition
  const { title, transition, setTransition } = useOutletContext()

  const navigate = useNavigate()
  const location = useLocation()
  const [searchParams, setSearchParams] = useSearchParams()
  const searchInput = useRef()

  const page = searchParams.get('page')
  const search = searchParams.get('search')
  // Reuse filter keys yang sudah ada: name/from/to (bisa kamu map di backend)
  const name = searchParams.get('name')       // bisa dipakai untuk reference_id
  const from = searchParams.get('from')       // outlet asal
  const to = searchParams.get('to')           // outlet tujuan

  const orderBy = searchParams.get('order_by')
  const direction = searchParams.get('direction')

  // ⟵ Ganti sumber data ke stock-transfer
  const { data: transferData, isLoading: isLoadingTransferData, mutate: mutateTransferData } =
    useStockTransferRepositories({
      page,
      search,
      name,      // mis. map ke reference_id di repo
      from,      // outlet asal
      to,        // outlet tujuan
      order_by: orderBy,
      direction
    })

  useEffect(() => {
    console.log(transferData)
    window.history.replaceState({}, document.title)
    if (transition.reverse) {
      setTransition({ type: 'slide', reverse: false })
    }
  }, [])

  useEffect(() => {
    searchInput.current?.focus()
  }, [search])

  useEffect(() => {
    if (search === "") {
      navigate(``, { replace: true })
    }
    if (isLoadingTransferData) nProgress.start()
    else nProgress.done()
  }, [transferData, isLoadingTransferData])

  // Handlers
  const updateFilter = (value) => setSearchParams(value)
  const removeFilter = () => setSearchParams({})
  const toggleSort = (value) => {
    if ((direction === null || direction === 'desc') || orderBy !== value) {
      setSearchParams({ order_by: value, direction: 'asc' })
    } else {
      setSearchParams({ order_by: value, direction: 'desc' })
    }
  }

  // =========================
  //   TABEL & KOLOM LIST
  // =========================
  const dataListHeaders = [
    { isAction: false, content: "Ref ID",         sortKey: "reference_id" },
    { isAction: false, content: "Produk",         sortKey: "product_unit" },
    { isAction: false, content: "Outlet",           sortKey: "outlet" },
    { isAction: false, content: "Reference Type",           sortKey: "reference_type" },
    { isAction: false, content: "Qty",            sortKey: "total_qty" },
    { isAction: false, content: "Lot Count",      sortKey: "moved_lot_count" },
    { isAction: false, content: "Tanggal",        sortKey: "created_at" },
    { isAction: false, content: "Dibuat Oleh",    sortKey: "created_by" },
    { isAction: true,  content: null }
  ]

  const dataListColumns = [
    {
      type: "default",
      bold: true,
      content: (v) => v.reference_id || v.id
    },
    {
      type: "default",
      bold: false,
      content: (v) => v.product_unit || v.product || v.product_name || '-'
    },
    {
      type: "default",
      bold: false,
      content: (v) => v.outlet || '-'
    },
    {
      type: "default",
      bold: false,
      content: (v) => v.reference_type || '-'
    },
    {
      type: "default",
      bold: false,
      content: (v) => (v.total_qty ?? v.qty ?? v.quantity ?? 0)
    },
    {
      type: "default",
      bold: false,
      content: (v) => (v.moved_lot_count ?? v.lot_count ?? (Array.isArray(v.lots) ? v.lots.length : '-'))
    },
    {
      type: "default",
      bold: false,
      content: (v) => {
        const d = v.transaction_date || v.created_at || v.updated_at
        return d ? moment(d).format('MMMM D, YYYY') : '-'
      }
    },
    {
      type: "default",
      bold: false,
      content: (v) => v.created_by || v.user || '-'
    },
    // {
    //   type: "action",
    //   content: (v) => (
    //     <>
    //       {can('stock_transfer.update') && (
    //         <Link
    //           to={`${v.id || v.reference_id}/detail`}
    //           state={{ back: title, from: location?.pathname, transition: 'slide' }}
    //           className="inline-flex items-center p-1 text-white transition rounded-full bg-neutral-800 active:hover:scale-90"
    //           title="Detail / Edit"
    //         >
    //           <Pencil className="w-6 h-6" />
    //         </Link>
    //       )}

    //       {/* Tambahkan tombol Delete bila memang diizinkan
    //       {can('stock_transfer.delete') && (
    //         <Delete data={v} onSuccess={() => mutateTransferData()} />
    //       )} */}
    //     </>
    //   )
    // }
  ]

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between text-xs">
        <div className="flex items-center sm:space-x-2">
          <div className="relative hidden sm:block">
            <div className="absolute inset-y-0 flex items-center pl-3 pointer-events-none">
              <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4" width={24} height={24} viewBox="0 0 24 24" strokeWidth={1} stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round">
                <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                <circle cx={10} cy={10} r={7}></circle>
                <line x1={21} y1={21} x2={15} y2={15}></line>
              </svg>
            </div>
            <input
              ref={searchInput}
              onChange={(e) => setSearchParams({ search: e.target.value })}
              value={search ?? ''}
              type="text"
              placeholder={`${lang.search} Stock Transfer`}
              autoComplete="off"
              className="w-64 py-3 pl-8 pr-4 text-xs transition border border-neutral-200 focus:outline-none rounded-xl focus:border-neutral-400 focus:ring focus:ring-neutral-200"
            />
          </div>

          {/* Reuse filter lama (name/from/to). Mapping ke backend di repo */}
          <Filter
            onSubmit={updateFilter}
            onRemove={removeFilter}
            data={Object.fromEntries(Object.entries({ name, from, to }).filter(([_, v]) => v != null))}
          />
        </div>

        <div className="flex items-center space-x-2">
          {can('stock_transfer.create') && (
            <div>
              <Link
                to="create"
                onClick={() => { setTransition({ type: 'slide', reverse: true }) }}
                state={{ back: title, from: location?.pathname, transition: { type: 'slide' } }}
                className="inline-flex items-center px-4 py-3 space-x-2 text-white transition bg-neutral-800 rounded-xl active:hover:scale-90"
              >
                <Plus className="w-4 h-4" stroke={1.5} />
                <span>{lang.create}</span>
              </Link>
            </div>
          )}
        </div>
      </div>

      <Table
        isLoading={isLoadingTransferData}
        data={transferData?.data ?? []}
        headers={dataListHeaders}
        columns={dataListColumns}
        key={(v) => v.id || v.reference_id}
        isEmpty={(!transferData?.data?.length) && !search && !isLoadingTransferData}
        isEmptyOnSearching={(!transferData?.data?.length) && !!search && !isLoadingTransferData}
        toggleSort={toggleSort}
        orderBy={orderBy}
        direction={direction}
      />

      <Pagination
        links={transferData?.links}
        from={transferData?.from}
        to={transferData?.to}
        total={transferData?.total}
      />
    </div>
  )
}
